(() => {
  if (customElements.get('raeliv-back-in-stock')) return;
  class RestockCapture extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-bis-variants]').textContent);
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-bis-status]');
      this.submit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.submit);
      this.sync();
      this.timer = setInterval(() => this.sync(), 400);
    }
    disconnectedCallback() { clearInterval(this.timer); this.form?.removeEventListener('submit', this.submit); }
    sync() {
      const purchaseForm = document.getElementById(this.dataset.formId);
      const id = purchaseForm?.querySelector('[name=id]')?.value || this.dataset.selectedId;
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.hidden = !variant || variant.available;
      if (String(this.variant?.id) !== String(variant?.id)) {
        this.status.textContent = '';
        this.querySelector('[data-bis-variant]').textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
      }
      this.variant = variant;
    }
    async onSubmit(event) {
      event.preventDefault(); this.sync();
      if (!this.variant || this.variant.available || this.busy) return;
      const variant = this.variant;
      const email = this.form.elements.email.value.trim();
      if (!this.form.reportValidity()) return;
      this.busy = true;
      const button = this.form.querySelector('button'); button.disabled = true;
      this.status.textContent = 'Saving your request…';
      try {
        const endpoint = window.RAELIV_BIS_ENDPOINT;
        const payload = endpoint ? { email, productId: this.dataset.productId, variantId: String(variant.id), handle: this.dataset.productUrl.split('/').pop() } : {
          data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } } } }
        };
        const response = await fetch(endpoint || 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=X9J979', {
          method: 'POST', headers: { 'Content-Type': 'application/json', ...(endpoint ? {} : { revision: '2026-07-15' }) }, body: JSON.stringify(payload), signal: AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('capture_http_' + response.status);
        // A success is displayed only for the option that was actually submitted.
        if (String(this.variant?.id) === String(variant.id)) this.status.textContent = 'You’re on the list for ' + (variant.title === 'Default Title' ? this.dataset.productName : variant.title) + '. Thank you!';
        else this.status.textContent = 'Your request for ' + variant.title + ' was saved. Submit again for your newly selected option.';
      } catch (error) {
        console.warn('RAELIV BIS capture failed:', error.name, error.message);
        this.status.textContent = 'We couldn’t confirm your request. Please try again, or email hi@raeliv.boutique with your selected option.';
      } finally { this.busy = false; button.disabled = false; }
    }
  }
  customElements.define('raeliv-back-in-stock', RestockCapture);
})();
